import type { RouteRecordRaw } from 'vue-router'
const routers: RouteRecordRaw = {
  path: '/shp-area-setting',
  name:'ShpAreaSetting',
  meta: {
    title: '地区设置'
  },
  children: [
    {
      path: 'list',
      name: 'ShpAreaSettingList',
      meta: {
        title: '地区设置'
      },
      component: ()=>{return import("@/views/shp-area-setting/ShpAreaSettingList.vue")}
    },
    {
      path: 'add',
      name: 'ShpAreaSettingAdd',
      meta: {
        title: '地区设置'
      },
      component: ()=>{return import("@/views/shp-area-setting/ShpAreaSettingAdd.vue")}
    },
    {
      path: 'edit',
      name: 'ShpAreaSettingEdit',
      meta: {
        title: '地区设置'
      },
      component: ()=>{return import("@/views/shp-area-setting/ShpAreaSettingEdit.vue")}
    }
  ]
}
export default routers
